import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _styled from "@emotion/styled-base";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
} // externals


import React, { useState, useEffect } from 'react';
// utils
import { getLatAndLongByGeolocation } from '@jelly/utils'; // components

import { GoogleMapsReactWrap } from './GoogleMapsReactWrap';
import { MapMarker } from './MapMarker';
import { MapYouAreHereBox } from './MapYouAreHereBox';

var Wrapper = _styled("div", {
  target: "eahmhcq0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "gpemya",
  styles: "overflow:hidden;width:100%;height:100%;"
} : {
  name: "gpemya",
  styles: "overflow:hidden;width:100%;height:100%;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

/**
 * NearYouMap
 *
 * A Google map along with pins for companies near user's current location.
 * The map API is pre-loaded in the base .twig
 * Set the "you are here" coordinates for the map. Defaults to Purch in Ogden.
 * This value is where a marker is dropped and is the initial center of the map. It can be
 * overwritten by incoming coordinates via the `center` prop.
 */
export function NearYouMap(_ref) {
  var _ref$zoom = _ref.zoom,
      zoom = _ref$zoom === void 0 ? 8 : _ref$zoom,
      center = _ref.center,
      services = _ref.services;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      userCenter = _useState2[0],
      setUserCenter = _useState2[1];

  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var latLongObj;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return getLatAndLongByGeolocation();

              case 2:
                latLongObj = _context.sent;
                setUserCenter(_objectSpread({}, latLongObj));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();

    fetchData();
  }, []);
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(GoogleMapsReactWrap, {
    center: _objectSpread(_objectSpread({}, userCenter), center),
    zoom: zoom
  }, /*#__PURE__*/React.createElement(MapMarker, _extends({
    RenderMapInfoBox: MapYouAreHereBox,
    fillPrimary: "#00449E",
    fillSecondary: "#76C4E2",
    zIndex: "998"
  }, userCenter)), services.map(function (service) {
    return /*#__PURE__*/React.createElement(MapMarker, _extends({
      fillPrimary: "#E7040F",
      fillSecondary: "#FF725C",
      key: service.id
    }, service));
  })));
}